import { store } from '../../stateManager'
import { Scope } from './interface'

export default function a8func(scope: Scope) {
    const state = store.getState()
    const appType = state.apps.selectedApp.type
    return `
        declare var params: Object;
        declare var crypto: any;
        declare var xmlparser: any;
        declare var soap: any;
        declare var he: any;
        declare var a8func: any;
        ${scope === 'functionServer' ? 'declare var FormData: any;' : ''}
        ${scope === 'functionServer' ? 'declare var Buffer: any;' : ''}
        ${scope === 'functionServer' ? 'declare var console: any;' : ''}
        ${scope === 'functionServer' ? 'declare var session: any;' : ''}
        ${scope === 'functionServer' ? 'declare var https: any;' : ''}
        ${scope === 'functionServer' ? `
            interface BindParam {
                key: string, 
                value: any, 
                valueInfo?: any, 
                update?: boolean
            };
            declare var bindParams: any; 
        ` : ''}

        interface IValueInfo {
            filename?:string, mimetype?: string
        };

        declare function addVariable(name: string, value:any, type?: string, valueInfo?: IValueInfo): Promise<any>;
        declare function updateVariable(name: string, value:any, type?: string, valueInfo?: IValueInfo): Promise<any>;
        declare function getVariables(): Promise<any>;
        ${appType === 'a8flow' ? 'declare function clearBindParams(bindParams: string[], recursive?: boolean ): void' : ''}
        ${(appType === 'a8solo' || appType === 'a8chat') && scope !== 'functionServer' ? 'declare function clearBindParams(bindParams: string[], recursive?: boolean ): void' : '' }
        ${scope === 'functionServer' && (appType === "a8solo" || appType === "a8chat") ? 'declare function deleteVariable(variableName: string, softDelete?: boolean): void' : ''}
        ${scope === 'functionServer' && (appType === "a8solo" || appType === "a8chat") ? 'declare function deleteVariables(variableName: string[], softDelete?: boolean): void' : ''} `
}
